/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_HipsInputs */

const en_us2_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Around the fullest part of the glutes, feet together, weight on both legs.`)
};

const pt_br2_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais saliente dos glúteos, com os pés juntos e o peso nas duas pernas.`)
};

const es_419_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la parte más prominente de los glúteos, con los pies juntos y el peso en ambas piernas.`)
};

const pt_pt2_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na parte mais saliente dos glúteos, com os pés juntos e o peso nas duas pernas.`)
};

const fr_fr2_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au plus saillant des fessiers, pieds joints, poids sur les deux jambes.`)
};

const de_de2_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An der breitesten Stelle des Gesäßes, Füße zusammen, Gewicht auf beiden Beinen.`)
};

const it_it2_body_measures_how_hips = /** @type {(inputs: Body_Measures_How_HipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel punto più sporgente dei glutei, piedi uniti e peso su entrambe le gambe.`)
};

/**
* | output |
* | --- |
* | "Around the fullest part of the glutes, feet together, weight on both legs." |
*
* @param {Body_Measures_How_HipsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_hips = /** @type {((inputs?: Body_Measures_How_HipsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_HipsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_hips(inputs)
	if (locale === "es-419") return es_419_body_measures_how_hips(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_hips(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_hips(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_hips(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_hips(inputs)
	return en_us2_body_measures_how_hips(inputs)
});
export { body_measures_how_hips as "body-measures.how_hips" }